/**
 * Manual product grid — per-card media swiper with pagination dots.
 */
export class ManualProductGrid extends HTMLElement {
  constructor() {
    super();
    this.swipers = [];
  }

  connectedCallback() {
    this.initMediaSwipers();
  }

  disconnectedCallback() {
    this.swipers.forEach((swiper) => swiper.destroy?.());
    this.swipers = [];
  }

  initMediaSwipers() {
    if (!window.Swiper) return;

    this.querySelectorAll('[data-mpg-media-swiper]').forEach((element) => {
      if (element.classList.contains('swiper-initialized')) return;

      const slideCount = element.querySelectorAll('.swiper-slide').length;
      if (slideCount <= 1) return;

      const paginationEl = element.querySelector('.mpg-card__pagination');
      const swiper = new window.Swiper(element, {
        slidesPerView: 1,
        loop: false,
        watchOverflow: true,
        pagination: paginationEl
          ? {
              el: paginationEl,
              clickable: true,
            }
          : undefined,
      });

      this.swipers.push(swiper);
    });
  }
}

if (!customElements.get('manual-product-grid')) {
  customElements.define('manual-product-grid', ManualProductGrid);
}
